import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
}), 'SortSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SortSharp.js
// module id = 6321
// module chunks = 2